export default {
  "content": "<g clip-path=\"url(#clip0_30_1246)\" fill=\"#7B61FF\"><path d=\"M25.745 7.667l-8.5 9.5a1 1 0 01-1.526-.043l-4-5 1.562-1.249 3.262 4.077 7.712-8.619 1.49 1.334z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32 0a4 4 0 014 4v16a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4h28zM4 2a2 2 0 00-2 2v16a2 2 0 002 2h28a2 2 0 002-2V4a2 2 0 00-2-2H4z\"/></g><defs><clipPath id=\"clip0_30_1246\"><rect width=\"36\" height=\"24\" rx=\"4\" fill=\"#fff\"/></clipPath></defs>",
  "attrs": {
    "width": "36",
    "height": "24",
    "viewBox": "0 0 36 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};